import I18n from 'I18n';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_TAG_TEXT_LENGTH = 20;
export function getTagText(teamNames) {
  const preferred = I18n.text('app-governance-lib.installPermissions.options.specificUsers.teamAccessTag.viaTeam', {
    count: teamNames.length,
    teamName: teamNames[0],
    extraCount: teamNames.length - 1
  });
  if (preferred.length > MAX_TAG_TEXT_LENGTH) {
    return I18n.text('app-governance-lib.installPermissions.options.specificUsers.teamAccessTag.viaMultipleTeams', {
      count: teamNames.length
    });
  }
  return preferred;
}
export function TeamAccessTag({
  teamNames
}) {
  if (teamNames.length === 0) {
    return null;
  }
  const tagText = getTagText(teamNames);
  const tooltipText = I18n.text('app-governance-lib.installPermissions.options.specificUsers.teamAccessTag.tooltip', {
    count: teamNames.length,
    teamName: teamNames[0],
    teamNames: teamNames.join(', ')
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    title: tooltipText,
    children: /*#__PURE__*/_jsx(Tag, {
      use: "success",
      children: /*#__PURE__*/_jsx(TruncateString, {
        hideDefaultTooltip: true,
        tooltip: false,
        matchContentWidth: true,
        children: tagText
      })
    })
  });
}